import './i18n/config';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// import "./index.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
// Ant Design
import 'antd/dist/reset.css'; // for AntD v5
import 'assets/scss/custom.scss';
import 'assets/scss/notifications.scss';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'helpers/YupLocale';
import { store } from 'store/index.ts';

import App from './App.tsx';
import { armChunkErrorRecovery, reloadOnceForChunkError } from './utils/chunkErrorRecovery';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// A deploy/restart can replace built assets while a tab is still open; recover
// silently instead of surfacing a false "server error" for a stale chunk.
// Don't preventDefault() here - that suppresses Vite's descriptive error and
// leaves React.lazy crashing on `.default` of undefined instead, which
// ErrorBoundary can no longer recognize as a chunk error if this reload fails.
window.addEventListener('vite:preloadError', () => {
  reloadOnceForChunkError();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>
);

armChunkErrorRecovery();
